import * as ts from "../../common/Translator";
import {isEnglish, translateId} from "../../common/Translator";
import * as bf from "../../constants/BusinessFunction";
import * as buttons from "../../constants/EditToolbarButtons";
import {
    userCan,
    userCanApprove,
    userCanCreate,
    userCanDelete,
    userCanDeleteDraft,
    userCanEdit,
    userCanList,
    userCanNotEdit,
    userCanView
} from "../../login/Security";
import * as CapabilityType from '../../constants/CapabilityType'
import * as GenerationType from "../../constants/GenerationType";
import * as ViewMode from '../../constants/ViewMode'
import {findEntityMaxReviseCount, isDocument} from "../../login/ClientCache";
import {currentUserEmployeeId} from "../../login/LoginPresenter";
import {exportButton} from "../ReportViewer";
import * as OutputFormat from "../../constants/OutputFormat";
import {TreeViewImpl} from "../treeView/TreeViewImpl";
import {TreeViewForEditView} from "../treeView/TreeViewForEditView";
import {hasParentEntity} from "../treeView/TreeViewForListView";
import * as cmn from "../../common/NamaCommon";
import * as NamaURLS from "../../constants/NamaURLS";
import {NamaRouterInstance} from "../../routing/NamaRouter";
import * as places from "../../routing/places";
import {describe, getFunctionShortCut} from "../../common/ShortCutsUtil";
import {showHelpMSGs} from "../../common/GUIUtilities";

export function fillMoreMenuButtons(toolbar, buttons) {
    for (let button of buttons) {
        let buttonId = button.id;
        let buttonTitle = button.title;
        let parentButtonId = button.parentButtonId;
        if (!buttonId) {
            if (parentButtonId) {
                //$(`#moreMenu`).items.Add().Type(CommandType.Separator);
            }
        }
        else {
            if (parentButtonId)
                $(`#moreMenu_optionlist #${parentButtonId}`).append(`<li><a class='k-button' id = ${buttonId}>${buttonTitle}</a></li>`);
            else
                $("#moreMenu_optionlist").append(`<li><a class='k-split-button' id = ${buttonId}>${buttonTitle}</a></li>`);
            $(`#${buttonId}`).on("click", (e) => {
                $("#moreMenu_optionlist .k-split-button").remove();
                $("#moreMenu_optionlist .k-button").remove();
                button.clickFunction.call();
            });
        }
    }
}

export function calcBtnTitle(btnId) {
    let title = ts.translateId("BusinessFunction." + btnId);
    let shortCut = getFunctionShortCut(btnId);
    if (shortCut) {
        title += describe(shortCut);
    }
    return title;
}

export function initiEditScreenToolbar(toolbar, presenter) {
    let showHelpsExtraClass = "";
    if (localStorage.getItem("showHelpsIsActive"))
        showHelpsExtraClass = "k-state-selected";
    let toolBarItems = [
        {
            type: "button", id: 'newRecord',
            icon: 'plus',
            attributes: {title: calcBtnTitle(bf.newRecord), class: "k-primary"},
            click: (e) => {
                presenter.onNewRecord()
            }
        }, {
            type: "button",
            id: 'saveBtn',
            icon: 'save',
            click: (e) => {
                presenter.saveRecord()
            },
            attributes: {title: calcBtnTitle(bf.save), class: "k-primary"}
        }, {
            type: "button",
            id: 'saveAndContinueBtn',
            icon: "file-add",
            attributes: {title: calcBtnTitle(bf.saveAndContinue), class: "k-primary"},
            click: (e) => {
                presenter.saveAndContinue();
            },
        }, {
            type: "button",
            id: 'duplicateBtn',
            attributes: {title: calcBtnTitle(bf.duplicate), class: "k-primary"},
            icon: 'copy',
            click: (e) => {
                presenter.duplicateRecord()
            }
        }, {
            type: "button",
            id: 'saveDraftBtn',
            icon: 'track-changes',
            attributes: {title: calcBtnTitle(bf.accept), class: "k-primary"},
            click: (e) => {
                presenter.saveDraft()
            }
        }, {
            type: "button",
            id: 'refreshBtn',
            spriteCssClass: "fa fa-refresh",
            attributes: {title: calcBtnTitle(bf.refresh), class: "k-primary"},
            click: (e) => {
                presenter.onRefresh();
            }
        }, {
            type: "splitButton",
            id: 'printBtn',
            icon: 'print',
            attributes: {title: calcBtnTitle(bf.print), class: "k-primary"},
            menuButtons: [
                exportButton("exportAsPDF", "assets/namasoft/img/pdf.png", () => {
                    presenter.onPrint(OutputFormat.PDF);
                }),
                exportButton("exportAsDOCX", "assets/namasoft/img/docx.png", () => {
                    presenter.onPrint(OutputFormat.DOCX);
                }),
                exportButton("exportAsRTF", "assets/namasoft/img/rtf.png", () => {
                    presenter.onPrint(OutputFormat.RTF);
                }),
                exportButton("exportAsXLSX", "assets/namasoft/img/xlsx.png", () => {
                    presenter.onPrint(OutputFormat.XLSX);
                }),
                exportButton("exportAsXLS", "assets/namasoft/img/xls.png", () => {
                    presenter.onPrint(OutputFormat.XLS);
                }),
                exportButton("exportAsODT", "assets/namasoft/img/odt.png", () => {
                    presenter.onPrint(OutputFormat.ODT);
                }),
                exportButton("exportAsODS", "assets/namasoft/img/ods.png", () => {
                    presenter.onPrint(OutputFormat.ODS);
                }),
                exportButton("exportAsPPTX", "assets/namasoft/img/pptx.png", () => {
                    presenter.onPrint(OutputFormat.PPTX);
                }),
                exportButton("sendEmailWithResult", "assets/namasoft/img/mailReport.png", () => {
                    presenter.sendEmail();
                }),
            ],
            click: (e) => presenter.onPrint(OutputFormat.PDF, true)
        }, {
            type: "button",
            id: 'approvalBtn',
            spriteCssClass: "fa fa-thumbs-o-up",
            attributes: {title: calcBtnTitle(bf.approval), class: "k-primary"},
            click: (e) => {
                presenter.onApprove();
            }
        }, {
            type: "button",
            id: 'reviseBtn',
            icon: 'track-changes-accept',
            attributes: {title: calcBtnTitle(bf.revise), class: "k-primary"},
            click: (e) => {
                presenter.revise();
            }
        }, {
            type: "button",
            id: 'unReviseBtn',
            icon: 'track-changes-reject',
            attributes: {title: calcBtnTitle(bf.unrevise), class: "k-primary"},
            click: (e) => {
                presenter.unRevise();
            }
        }, {
            type: "button",
            id: bf.listView,
            icon: 'align-justify',
            attributes: {title: calcBtnTitle(bf.listView), class: "k-primary"},
            click: (e) => {
                presenter.onListView()
            }
        }, {
            type: "button",
            id: "showHelpMsgs",
            spriteCssClass: "fa fa-question-circle",
            attributes: {title: translateId("showHelpMessage") + " [Ctrl + Alt + H]", class: "k-primary " + showHelpsExtraClass},
            click: (e) => {
                if (!localStorage.getItem("showHelpsIsActive")) {
                    showHelpMSGs(presenter);
                } else {
                    localStorage.removeItem("showHelpsIsActive");
                    presenter.start();
                }
            }
        }, {
            type: "button",
            id: 'treeViewBtn',
            spriteCssClass: "fa fa-tree",
            attributes: {title: calcBtnTitle(bf.treeView), class: "k-primary"},
            click: (e) => {
                presenter.treeView();
            }
        }, {
            type: "button",
            id: 'goToRecordBtn',
            icon: 'zoom',
            attributes: {title: calcBtnTitle(bf.goToRecord), class: "k-primary"}
        }, {
            type: "button",
            id: 'firstBtn',
            icon: isEnglish() ? 'arrow-double-60-left' : 'arrow-double-60-right',
            attributes: {title: calcBtnTitle(bf.first), class: "k-primary"}, click: (e) => {
                presenter.navigateFirst()
            }
        }, {
            type: "button",
            id: 'previousBtn',
            icon: isEnglish() ? 'arrow-60-left' : 'arrow-60-right',
            attributes: {title: calcBtnTitle(bf.previous), class: "k-primary"},
            click: (e) => {
                presenter.navigatePrevious()
            }
        }, {
            type: "button",
            id: 'nextBtn',
            icon: isEnglish() ? 'arrow-60-right' : 'arrow-60-left',
            attributes: {title: calcBtnTitle(bf.next), class: "k-primary"},
            click: (e) => {
                presenter.navigateNext()
            }
        }, {
            type: "button",
            id: 'lastBtn',
            icon: isEnglish() ? 'arrow-double-60-right' : 'arrow-double-60-left',
            attributes: {title: calcBtnTitle(bf.last), class: "k-primary"},
            click: (e) => {
                presenter.navigateLast()
            }
        }, {
            type: "button",
            id: 'deleteBtn',
            icon: 'delete',
            attributes: {title: calcBtnTitle(bf.$delete), class: "k-primary"},
            click: (e) => {
                presenter.onDelete()
            }
        }, {
            type: "button",
            id: 'homePageBtn',
            spriteCssClass: "fa fa-home",
            attributes: {title: calcBtnTitle('homePage'), class: "k-primary"},
            click: (e) => {
                NamaRouterInstance.goTo(new places.WelcomePlace());
            }
        },
        {
            type: "button",
            id: 'moreMenu',
            icon: 'more-horizontal',
            text: ts.translateId('more'),
            attributes: {title: calcBtnTitle('more'), class: "k-primary"},
            click: (e) => {
                presenter.showMoreMenu();
            },
        }
    ];
    toolbar.kendoToolBar({
        items: toolBarItems
    });
    for (let item of toolBarItems) {
        let span = toolbar.find("#" + item.id).find("span");
        if (span && span.hasClass("fa")) {
            span.removeClass("k-icon");
            span.removeClass("k-sprite");
        }
    }
    toolbar.data("kendoToolBar").resize();
    toolbar.find("#moreMenu").on('mouseover', function (e) {
        e.preventDefault();
        presenter.showMoreMenu();
    });

}

export function initTreeViewForEditing(splitter, presenter) {
    if (presenter.hasTree() && !splitter.data("kendoSplitter")) {
        let treeViewForEditView = new TreeViewForEditView(presenter.entityType);
        let treeViewImpl = new TreeViewImpl(treeViewForEditView.getTreeModelProviderForEditView(),
            treeViewForEditView.getHelperForEditView(), presenter, () => onTreeNodeSelection(treeViewImpl, presenter));
        presenter.treeView = treeViewImpl;
        treeViewImpl.drawTreeView();
        splitter.kendoSplitter({
            orientation: "horizontal",
            panes: [{}, {size: '15%', collapsible: true}]
        });
    }
    else if (splitter.data("kendoSplitter")) {
        splitter.data("kendoSplitter").toggle(".k-pane:last");
    }
}

function onTreeNodeSelection(treeViewImpl, presenter) {
    let selectedNode = treeViewImpl.getSelectedNode();
    if (selectedNode.id === presenter.place.id)
        return;
    cmn.ajaxJSON(NamaURLS.FIND_BY_ID, {
        entityType: treeViewImpl.treeModelProvider.entityType,
        id: selectedNode.id
    }, (result) => {
        let record = result.data;
        presenter.place.id = selectedNode.id;
        if (presenter.place.view === ViewMode.NEW)
            presenter.place.view = ViewMode.EDIT;
        presenter.editRecord(record, true)
    });

}

function preValidateCreateNewRecord(presenter) {
    if (userCanEdit(presenter.entityType))
        return true;
    return userCanCreate(presenter.entityType);
}

function preValidateSaveAndContinue(presenter) {
    return preValidateSave(presenter) && preValidateCreateNewRecord(presenter);
}

function preValidateSave(presenter) {
    if (userCanNotEdit(presenter.entityType))
        return false;
    return preValidateEditedObjectRelatedButton(presenter);
}

function preValidateEditedObjectRelatedButton(presenter) {
    return presenter.record === null ? false : defaultToolBarButtonState(presenter);
}

function defaultToolBarButtonState(presenter) {
    return !presenter.isViewOnlyMode();
}

function isRevised(presenter) {
    let record = presenter.record;
    if (!record)
        return false;
    return record.revised;
}

export function isInNewMode(presenter) {
    return presenter.place.view === ViewMode.NEW;
}

function canDuplicate(presenter) {
    return !isInNewMode(presenter) && userCan(presenter.entityType, CapabilityType.Duplicate)
        && presenter.findGenerationType() !== GenerationType.GeneratedFinal;
}

function preValidateSaveDraft(presenter) {
    if (presenter.isViewOnlyMode())
        return false;
    if (isDocument(presenter.entityType)
        && presenter.record.commitedBefore === true)
        return false;
    if (userCanEdit(presenter.entityType))
        return true;
    return userCan(presenter.entityType, CapabilityType.SaveDraft);
}

function preValidateRefresh() {
    return true;
}

function preValidatePrint() {
    return defaultToolBarNavigationButtonState();
}

function defaultToolBarNavigationButtonState() {
    return true;
}

function preValidateGoToListView(presenter) {
    if (!userCanList(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateGoToRecord(presenter) {
    if (!userCanView(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateGoToFirstRecord(presenter) {
    if (!userCanView(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateGoToLastRecord(presenter) {
    if (!userCanView(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateGoToPreviousRecord(presenter) {
    if (!userCanView(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateGoToNextRecord(presenter) {
    if (!userCanView(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateDelete(presenter) {
    if (presenter.isNotEditableBySystem() || presenter.place.view === ViewMode.NEW)
        return false;
    if (presenter.record.commitedBefore === true)
        return userCanDelete(presenter.entityType);
    else
        return userCanDeleteDraft(presenter.entityType);
}

function preValidateApproval(presenter) {
    if (!userCanApprove(presenter.entityType))
        return false;
    if (!presenter.isApprovalPending())
        return false;
    return isUserEmployeeCandidate(presenter);
}

function isUserEmployeeCandidate(presenter) {
    let currentCandidates = presenter.record.currentApprovalCase ? presenter.record.currentApprovalCase.currentCandidates : "";
    return currentCandidates && currentCandidates.contains(currentUserEmployeeId());

}

function preValidateRevise(presenter) {
    if (!canBeRevised(presenter))
        return false;
    return userCan(presenter.entityType, CapabilityType.Revise
        + toReviseLevel(currentReviseLevelInt(presenter) + 1));
}

function toReviseLevel(level) {
    return "L" + level;
}

export function canBeRevised(presenter) {
    let revisedLevel = currentReviseLevelInt(presenter);
    let toBeRevisedCount = findEntityMaxReviseCount(presenter.entityType).reviseLevel;
    if (revisedLevel < toBeRevisedCount)
        return true;
    return false;
}

function currentReviseLevelInt(presenter) {
    if (shouldPreserveBackwardCompatibility(presenter))
        return 1;
    if (presenter.record === null)
        return 0;
    let levelString = presenter.record.reviseLevel;
    if (!levelString)
        return 0;
    return levelString.replace("L", "");

}

function shouldPreserveBackwardCompatibility(presenter) {
    return presenter.record && !presenter.record.reviseLevel && isRevised(presenter);
}

function preValidateUnrevise(presenter) {
    if (!canBeUnRevised(presenter))
        return false;
    return userCan(presenter.entityType, CapabilityType.Unrevise + currentReviseLevel(presenter));

}

function currentReviseLevel(presenter) {
    let currentLevel = currentReviseLevelInt(presenter);
    if (currentLevel === 0)
        return "";
    return toReviseLevel(currentLevel);
}

export function canBeUnRevised(presenter) {
    let revisedCount = currentReviseLevelInt(presenter);
    if (revisedCount > 0)
        return true;
    return false;
}

export function supportsTree(entityType) {
    return hasParentEntity(entityType);
}

function prevalidateTreeView(presenter) {
    return supportsTree(presenter.entityType);
}

export function prevalidateToolbarButtons(toolbar, presenter) {
    let toolbarData = toolbar.data("kendoToolBar");
    toolbarData.enable(toolbar.find("#newRecord"), enableButton(buttons.NEW_RECORD, presenter));
    toolbarData.enable(toolbar.find("#saveAndContinueBtn"), enableButton(buttons.SAVE_AND_CONTINUE, presenter));
    toolbarData.enable(toolbar.find("#duplicateBtn"), enableButton(buttons.DUPLICATE, presenter));
    toolbarData.enable(toolbar.find("#saveBtn"), enableButton(buttons.SAVE, presenter));
    toolbarData.enable(toolbar.find("#saveDraftBtn"), enableButton(buttons.SAVE_DRAFT, presenter));
    toolbarData.enable(toolbar.find("#refreshBtn"), enableButton(buttons.REFRESH, presenter));
    toolbarData.enable(toolbar.find("#printBtn"), enableButton(buttons.PRINT, presenter));
    toolbarData.enable(toolbar.find("#listView"), enableButton(buttons.LIST_VIEW, presenter));
    toolbarData.enable(toolbar.find("#goToRecordBtn"), enableButton(buttons.GO_TO_RECORD, presenter));
    toolbarData.enable(toolbar.find("#firstBtn"), enableButton(buttons.FIRST, presenter));
    toolbarData.enable(toolbar.find("#previousBtn"), enableButton(buttons.PREVIOUS, presenter));
    toolbarData.enable(toolbar.find("#nextBtn"), enableButton(buttons.NEXT, presenter));
    toolbarData.enable(toolbar.find("#lastBtn"), enableButton(buttons.LAST, presenter));
    toolbarData.enable(toolbar.find("#deleteBtn"), enableButton(buttons.DELETE, presenter));
    toolbarData.enable(toolbar.find("#approvalBtn"), enableButton(buttons.APPROVAL, presenter));
    toolbarData.enable(toolbar.find("#reviseBtn"), enableButton(buttons.REVISE, presenter));
    toolbarData.enable(toolbar.find("#unReviseBtn"), enableButton(buttons.UNREVISE, presenter));
    toolbarData.enable(toolbar.find("#treeViewBtn"), enableButton(buttons.TREE_VIEW, presenter));
}

function enableButton(id, presenter) {
    if (buttons.NEW_RECORD.equalsIgnoreCase(id))
        return preValidateCreateNewRecord(presenter);
    if (buttons.SAVE_AND_CONTINUE.equalsIgnoreCase(id))
        return preValidateSaveAndContinue(presenter);
    if (buttons.DUPLICATE.equalsIgnoreCase(id))
        return canDuplicate(presenter);
    else if (buttons.SAVE.equalsIgnoreCase(id))
        return preValidateSave(presenter);
    else if (buttons.SAVE_DRAFT.equalsIgnoreCase(id))
        return preValidateSaveDraft(presenter);
    else if (buttons.REFRESH.equalsIgnoreCase(id))
        return preValidateRefresh();
    else if (buttons.PRINT.equalsIgnoreCase(id))
        return preValidatePrint();
    else if (buttons.LIST_VIEW.equalsIgnoreCase(id))
        return preValidateGoToListView(presenter);
    else if (buttons.GO_TO_RECORD.equalsIgnoreCase(id))
        return preValidateGoToRecord(presenter);
    else if (buttons.FIRST.equalsIgnoreCase(id))
        return preValidateGoToFirstRecord(presenter);
    else if (buttons.PREVIOUS.equalsIgnoreCase(id))
        return preValidateGoToPreviousRecord(presenter);
    else if (buttons.NEXT.equalsIgnoreCase(id))
        return preValidateGoToNextRecord(presenter);
    else if (buttons.LAST.equalsIgnoreCase(id))
        return preValidateGoToLastRecord(presenter);
    else if (buttons.DELETE.equalsIgnoreCase(id))
        return preValidateDelete(presenter);
    else if (buttons.APPROVAL.equalsIgnoreCase(id))
        return preValidateApproval(presenter);
    else if (buttons.REVISE.equalsIgnoreCase(id))
        return preValidateRevise(presenter);
    else if (buttons.UNREVISE.equalsIgnoreCase(id))
        return preValidateUnrevise(presenter);
    else if (buttons.TREE_VIEW.equalsIgnoreCase(id))
        return prevalidateTreeView(presenter);
    return defaultToolBarNavigationButtonState();
}
